import React from 'react';
import Select from 'react-select';

interface SelectDropDownProps {
	options: any;
	onInputChange?: (e: any) => void;
	isClearable?: boolean;
	onChange?: (e: any) => void;
	value?: any;
	isMulti?: boolean;
	placeholder?: string;
	menuPortalTarget?: boolean;
}

const SelectDropDown = (props: SelectDropDownProps) => {
	const {
		options,
		onInputChange,
		isClearable,
		onChange,
		value,
		isMulti = false,
		placeholder = 'Select',
		menuPortalTarget = false
	} = props;
	return (
		<>
			<Select
				className="text-sm"
				theme={(theme: any) => ({
					...theme,
					borderRadius: 2,
				})}
				menuPortalTarget={menuPortalTarget === true ? document.body : null}
				styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 99999, border: 0, boxShadow: "none", }) }}
				placeholder={placeholder}
				isMulti={isMulti}
				options={options}
				onInputChange={onInputChange}
				isClearable={isClearable}
				onChange={onChange}
				value={value}
			/>
		</>
	);
};

export default SelectDropDown;
